import Sms from "@mui/icons-material/Sms";
import { PersonalEmailIcon, WorkEmailIcon } from "../../../styles/icons/email";
import { SlackIcon } from "../../../styles/icons/slack";
import { TeamsIcon } from "../../../styles/icons/teams";
import { WhatsAppIcon } from "../../../styles/icons/whatsapp";

import type { ChannelName } from "../types";
import type { SxProps, Theme } from "@mui/material";
import type { FC } from "react";

const NO_SX: SxProps<Theme> = {};

interface ChannelIconProps {
  channel?: ChannelName;
  fontSize?: "inherit" | "large" | "medium" | "small";
  sx?: SxProps<Theme>;
}

export const ChannelIcon: FC<ChannelIconProps> = ({ channel, fontSize = "large", sx = NO_SX }) => {
  switch (channel) {
    case "personal_email":
      return (
        <PersonalEmailIcon
          data-testid="personal_email-icon"
          fontSize={fontSize}
          sx={[{ paddingRight: "2px" }, ...(Array.isArray(sx) ? sx : [sx])]}
        />
      );
    case "work_email":
      return (
        <WorkEmailIcon
          data-testid="work_email-icon"
          fontSize={fontSize}
          sx={[{ paddingRight: "2px" }, ...(Array.isArray(sx) ? sx : [sx])]}
        />
      );
    case "slack":
      return <SlackIcon data-testid="slack-icon" fontSize={fontSize} sx={sx} />;
    case "teams":
      return <TeamsIcon data-testid="teams-icon" fontSize={fontSize} sx={sx} />;
    case "twilio":
      return <Sms data-testid="twilio-icon" color="primary" fontSize={fontSize} sx={sx} />;
    case "whatsapp":
      return <WhatsAppIcon data-testid="whatsapp-icon" fontSize={fontSize} sx={sx} />;
    case undefined:
    case null:
    default:
      return null;
  }
};

export function channelNameMap(channel: ChannelName): string {
  switch (channel) {
    case "personal_email":
      return "Personal Email";
    case "work_email":
      return "Work Email";
    case "slack":
      return "Slack";
    case "teams":
      return "Teams";
    case "twilio":
      return "SMS";
    case "whatsapp":
      return "WhatsApp";
    case null:
    default:
      return "";
  }
}
